import { atom, createStore } from "jotai";
import { SectionsList, SelectedSection } from "./components/MainPage/NotWorkArea(Side&Head)/SideBar/SideBarInterface";
import { defaultConfig } from "./components/MainPage/Tools/Consts";
import { ConfigLk, ConfigSmeta, getOptionsForUser, updateOptionsForUser } from "./components/Url";
import { getBrowserType, getOS, setActiveSection } from "./components/MainPage/Tools/Tools";
import { WebSocketClient } from "./components/smetaWebSocket";
import { AppThemeName, DEFAULT_APP_THEME, normalizeAppThemeName } from "./theme/appTheme";
import { requestLeaveAtom } from "./components/MainPage/Tools/leaveGuard";

export const smetaStore = createStore();

export const smetaWebSocket = atom<WebSocketClient>();

//backgroundprocessing
//bg процесс это отдельная секция, в которой идет отображение загрузки формирования отчёта
const selectedProcessAtom = atom<string>(""); // выбранный bg process
const listOfProcessesAtom = atom([]); // список всех bg процессов

export { selectedProcessAtom, listOfProcessesAtom };

//sidebar data
const selectedSectionAtom = atom<SelectedSection>({
  //данные о текущей выбранной секции
  ID: "",
  CLSID: "",
  Name: "",
  Image: "",
});
const defaultSelectedSection: SelectedSection = {
  ID: "",
  CLSID: "",
  Name: "",
  Image: "",
};
const sectionListAtom = atom<SectionsList[]>([]); // массив всех секций
const pushNewSectionAtom = atom(null, (get, set, newValue: SectionsList) => {
  //функция для добавления новой секции в массив секций
  const sections = get(sectionListAtom);
  const newSections = sections.concat(newValue);
  set(sectionListAtom, newSections);
});
const setSelectedSectionAtom = atom(null, async (_get, set, newValue: SelectedSection) => {
  //функция для изменения текущей выбранной секции
  const canLeave = await set(requestLeaveAtom, { reason: "section-change" });
  if (!canLeave) return;
  if (newValue.ID) {
    document.title = newValue.Name;
    updateOptionsForUser({
      ID: newValue.ID,
      CLSID: newValue.CLSID,
      Name: newValue.Name,
    });
  }
  set(selectedSectionAtom, newValue);
  setActiveSection(newValue.ID);
});

export { selectedSectionAtom, sectionListAtom, setSelectedSectionAtom, pushNewSectionAtom };

//theme slice
const userOptions = getOptionsForUser(); //опции для юзера, по конфигурации -> пользователю -> рабочему месту
const userTheme = (userOptions as { theme?: string } | undefined)?.theme;
const ipAtom = atom<string | null>(userOptions?.IP || null); // сервер перенаправления, для картинок и некоторых запросов
const pingIntervalAtom = atom<NodeJS.Timeout | null>(null);
const pingMinsAtom = atom(300000); //интервал времени когда посылать пинги на сервер
const redirectServer = atom(userOptions?.IP); // сервер перенаправления для получения ресурсов
const currentTheme = atom<AppThemeName>(normalizeAppThemeName(userTheme || DEFAULT_APP_THEME)); //текущая выбранная тема
const animationsAtom = atom<boolean>(userOptions?.animations || false); //вкл ли анимации
const refreshSectionDataAtom = atom<{ refresh: boolean; refreshId: string; CommitFormOnSection: string } | null>(null);
const workPlaceToolsAtom = atom(undefined); //кнопки для рабочего места, запрашиваются 1 раз за обновление страницы
const imagesAtom = atom([]); // объект путями до картинки на сервере

export {
  currentTheme,
  animationsAtom,
  refreshSectionDataAtom,
  pingIntervalAtom,
  pingMinsAtom,
  redirectServer,
  workPlaceToolsAtom,
  imagesAtom,
  ipAtom,
};

export const isAuthorized = atom(false);
export const headFormAtom = atom({});
export const hasStartPageAtom = atom(false);
export const resetWorkAreaAtom = atom(null, (get, set) => {
  const pingInterval = get(pingIntervalAtom);
  if (pingInterval) clearInterval(pingInterval);
  set(pingIntervalAtom, null);
  set(selectedSectionAtom, defaultSelectedSection);
  set(sectionListAtom, []);
  set(headFormAtom, {});
  set(hasStartPageAtom, false);
  set(refreshSectionDataAtom, null);
  set(workPlaceToolsAtom, undefined);
  set(imagesAtom, []);
});
export const appConfig = atom<{ smeta: ConfigSmeta; lk: ConfigLk }>({ ...defaultConfig });
//salary
export const renderingIdAtom = atom({ renderingId: 0, personId: 0 });
export const groupIdAtom = atom(0);
export const salaryRangeAtom = atom({ year: "", month: "", range: "0" });
export const leavesOpenAtom = atom(false);
export const isAdminAtom = atom<boolean>(userOptions?.isAdmin);
export const isSuperUserAtom = atom<boolean>(userOptions?.isSuperUser);
export const isOrgEnterAtom = atom<boolean>(userOptions?.isOrg);
export const configEnabledAtom = atom<boolean>(userOptions?.configEnabled);
export const personsTableCurrentId = atom(null);
export const helpContextAtom = atom<string | undefined>(userOptions?.helpContext);
export const sectionPersonsData = atom({});
export const userRightsAtom = atom<{ [key: string | number]: string }>({});
export const gridSelectedRecordColorAtom = atom<boolean>(userOptions?.gridSelectedRecordColor || false);
export const hideToastNotificationsAtom = atom<boolean>(userOptions?.hideToastNotifications || false);
export const editorCash = atom({
  detailsOpen: false,
});
export const systemInfoAtom = atom({
  os: getOS(),
  browser: getBrowserType(),
});
